module.exports = __webpack_public_path__ + "img/16l013-15.8273c3dd.jpg";